export default __webpack_public_path__ + "static/cpanel-dc97dda727169b14770935b6ad7a0002.webp";